/** FROZEN (W0-contracts). Calls owns implementations; no capture or permissions at module load. */
import type { ReactElement } from 'react';
import type { Part } from '@/model';
import type { PartRendererProps } from '@/features/chat/registry';
import { CallsHost as Host } from './components/CallsHost';
import { CallRecordPart as Record } from './components/CallRecordPart';
import { callRecordText as recordText } from './call-record';

/** Shell mounts once for the entire signed-in session, independent of the current route. */
export function CallsHost(): ReactElement | null { return <Host/>; }
/** Register only the composite key system:call; retain centered system-line layout. */
export function CallRecordPart(props: PartRendererProps): ReactElement | null { return <Record {...props}/>; }
/** Null for any part other than system/event=call; translate keys belong to the calls namespace. */
export function callRecordText(
  part: Part,
  translate: (key: string, values?: Record<string, unknown>) => string,
): string | null { return recordText(part,translate); }
